module.exports = __webpack_public_path__ + "media/images/lp/industries/realestate/apple-tokyo-7f560db43d19b68239f0fb0032f2b5f8.png";